import type { FunctionComponent, ReactNode } from 'react';

import S from './style.scss';

const tabs = [
  'About You',
  'Practice & Expertise',
  'Experience & Training',
  'Portfolio',
] as const;

export type TabT = typeof tabs[number];

type PropsT = {
  setTab: (tab: TabT) => void;
  tab: TabT;
  tabValid: boolean;
};

const Header: FunctionComponent<PropsT> = ({ setTab, tab, tabValid }) => {
  const nodes: ReactNode[] = [];

  for (let i = 0; i < tabs.length; ++i) {
    const index = (i + 1).toString().padStart(2, '0');
    const item = tabs[i];
    if (!item) throw Error('Missing item');

    let className = S.item;
    if (item === tab) className += ` ${S.current}`;

    const onClick = item === tab ? undefined : () => {
      setTab(item);
    };

    nodes.push(
      <div
        className={className}
        key={`${index}/${item}`}
        onClick={onClick}
        onKeyDown={onClick ? (e) => {
          if (e.key === 'Enter') onClick();
        } : undefined}
        role="button"
        tabIndex={0}
      >
        <span styleName="index">{index} /</span> {item}
      </div>,
    );
  }

  let containerClassName = S.container;
  if (!tabValid) containerClassName += ` ${S.tabInvalid}`;

  return (
    <div className={containerClassName}>{nodes}</div>
  );
};

export default Header;
